<template>
  <div>
    <CRow class="mb-3">
      <CCol sm="12">
        <label class="mb-2">{{ $pgettext('tag_definitions.form', 'Options') }}</label>
        <table class="table table-sm">
          <thead>
            <tr>
              <th style="width: 45%">{{ $pgettext('tag_definitions.form', 'Label') }}</th>
              <th style="width: 45%">{{ $pgettext('tag_definitions.form', 'Value') }}</th>
              <th style="width: 10%" class="text-center">{{ $pgettext('tag_definitions.form', 'Actions') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(option, index) in config.options" :key="index">
              <td>
                <CInput
                    v-model="option.label"
                    @input="updateValue(index)"
                    :placeholder="$pgettext('tag_definitions.placeholder', 'Display label')"
                />
              </td>
              <td>
                <CInput
                    v-model="option.value"
                    :placeholder="$pgettext('tag_definitions.placeholder', 'Internal value')"
                />
              </td>
              <td class="text-center">
                <CButton
                    color="danger"
                    variant="ghost"
                    size="sm"
                    @click="removeOption(index)"
                    v-if="config.options.length > 1"
                >
                  <CIcon name="cipTrashFull"/>
                </CButton>
              </td>
            </tr>
          </tbody>
        </table>
        <CButton color="primary" variant="outline" @click="addOption" class="mt-2">
          <CIcon name="cipPlus" class="mr-1"/>
          <span>{{ $pgettext('tag_definitions.form', 'Add Option') }}</span>
        </CButton>
      </CCol>
    </CRow>
  </div>
</template>

<script>
export default {
  name: "CheckboxInputConfig",
  data() {
    return {
      config: {
        type: 'checkbox',
        options: [{value: '', label: ''}]
      }
    }
  },
  methods: {
    onReset(data) {
      this.config = {
        type: 'checkbox',
        options: [{value: '', label: ''}],
        ...data
      }
    },
    onSave() {
      return this.config
    },
    addOption() {
      this.config.options.push({value: '', label: ''})
    },
    removeOption(index) {
      this.config.options.splice(index, 1)
    },
    updateValue(index) {
      const label = this.config.options[index].label
      if (!label) {
        this.config.options[index].value = ''
        return
      }

      // Generate value from label (lowercase, spaces to underscores, remove special chars)
      const generatedValue = label
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9\s_-]/g, '')
        .replace(/[\s-]+/g, '_')
        .replace(/_+/g, '_')
        .replace(/^_|_$/g, '')

      this.config.options[index].value = generatedValue
    }
  }
}
</script>
